/**
 * External URL opener — Capacitor-aware.
 *
 * On the web, we simply use window.open(url, "_blank").
 * On native iOS/Android, Capacitor's WebView cannot host OAuth redirects
 * back to arbitrary web origins, so we route through the Capacitor
 * `Browser` plugin — which opens SFSafariViewController / Chrome Custom Tabs
 * with real cookie + redirect support.
 *
 * Anywhere ClientDesk VA opens an external link (OAuth, Stripe client
 * invoice checkout, meeting links, portal links, legal pages) should call
 * `openExternal(url)` instead of `window.open(url, "_blank")`.
 */
import { isNativeApp } from "@/lib/platform";

export async function openExternal(url) {
  if (!url) return;
  if (isNativeApp()) {
    try {
      // Dynamic import so the web build never bundles the Capacitor Browser
      // plugin unless it's actually needed at runtime.
      const { Browser } = await import("@capacitor/browser");
      await Browser.open({ url });
      return;
    } catch (_) {
      // Fall through to window.open if the plugin isn't available.
    }
  }
  window.open(url, "_blank", "noopener,noreferrer");
}
